export const UPDATE_ZIP = 'UPDATE_ZIP';
export const SELECT_FAMILY_TYPE = 'SELECT_FAMILY_TYPE';
export const UPDATE_AGE = 'UPDATE_AGE';
export const SELECT_MEDICARE = 'SELECT_MEDICARE';
export const SELECT_BUDGET = 'SELECT_BUDGET';
export const SELECT_TRAVEL = 'SELECT_TRAVEL';
export const UPDATE_HOUSEHOLD_SIZE = 'UPDATE_HOUSEHOLD_SIZE';
export const UPDATE_KIDS_COUNT = 'UPDATE_KIDS_COUNT';
export const UPDATE_INCOME = 'UPDATE_INCOME';
export const UPDATE_EMPLOYEE_COUNT = 'UPDATE_EMPLOYEE_COUNT';
export const SELECT_EMPLOYEE_BUDGET = 'SELECT_EMPLOYEE_BUDGET';
export const SELECT_EMPLOYEE_PREF = 'SELECT_EMPLOYEE_PREF';
export const UPDATE_QUOTE = 'UPDATE_QUOTE';
export const RESET_QUOTE = 'RESET_QUOTE';
export const CHANGE_SELECTED_PLAN = 'CHANGE_SELECTED_PLAN';
export const SET_STEP = 'SET_STEP';
export const START_OVER = 'START_OVER';
export const FAIL_REST_REQUEST = 'FAIL_REST_REQUEST';
export const FETCH_COUNTIES = 'FETCH_COUNTIES';
export const SET_RESULTS = 'SET_RESULTS';
export const SET_FIELD_VALUE = 'SET_FIELD_VALUE';
export const SET_VISIBILITY = 'SET_VISIBILITY';

export const TOGGLE_IN_QUIZ = 'TOGGLE_IN_QUIZ';
export const TOGGLE_IN_RESULTS = 'TOGGLE_IN_RESULTS';
export const UPDATE_TOP_BANNER = 'UPDATE_TOP_BANNER';
export const UPDATE_HEADER_HOURS = 'UPDATE_HEADER_HOURS';
export const UPDATE_HEADER_PHONE = 'UPDATE_HEADER_PHONE';
export const UPDATE_HEADER_PREMIUM = 'UPDATE_HEADER_PREMIUM';
export const UPDATE_HEADER_SCROLLER = 'UPDATE_HEADER_SCROLLER';
export const UPDATE_RESULTS_RATINGS = 'UPDATE_RESULTS_RATINGS';
export const UPDATE_RESULTS_FOOTER = 'UPDATE_RESULTS_FOOTER';



// WEBPACK FOOTER //
// ./src/redux/actions/types.js